import { type TranslationIDs, useIntl } from '@capsicum/common';
import { ExternalLinkIcon } from '@capsicum/common-web/icons';
import { type UkRiskLinkKeys, useShowHeaderWarning } from '@capsicum/features/regulations/shared';
import styled, { useTheme } from 'styled-components';

export type UkRiskLinkProps = {
	iconSize?: number;
	page: UkRiskLinkKeys;
	text?: TranslationIDs;
};

export const UkRiskLink = ({
	iconSize = 16,
	page,
	text = 'jurisdictionRequirements.ukRiskLink.linkText'
}: UkRiskLinkProps) => {
	const { colors } = useTheme();
	const { $t } = useIntl();
	const { riskLink, shouldShowUkRiskLink } = useShowHeaderWarning();

	if (!shouldShowUkRiskLink(page)) return null;

	return (
		<S.Link data-testid={`${page}-uk-risk-link`} href={riskLink} target="_blank">
			{$t(text)}
			<S.ExternalLink color={colors.icons.brand.enabled} height={iconSize} width={iconSize} />
		</S.Link>
	);
};

namespace S {
	export const Link = styled.a`
		${({ theme }) => theme.fonts.text.text2};
		line-height: ${({ theme }) => theme.fonts.text.text5['line-height']};
		text-decoration: underline;
		color: ${({ theme }) => theme.colors.text.brand.enabled};
	`;

	export const ExternalLink = styled(ExternalLinkIcon)`
		display: inline-block;
		margin: ${({ theme }) => theme.spacings.xxxsmall};
		vertical-align: middle;
	`;
}
